'use strict';

var FILE_EXAMPLES = {
    'tags': [{
        label: 'Eksempel ID Tag',
        text: 'Lokalisert på A-stolpe i førerdør åpning.\n\nInneholder: VIN, vektinformasjon og produksjonsdata.',
        image: '/images/teknisk/Eldre ID Tag Eksempel.png'
    }, {
        label: 'Eksempel Body Tag',
        text: 'Ofte plassert øverst på torpedovegg mot førerside.\n\nInneholder: Fargekode, trimkode og produksjonsinformasjon.',
        image: '/images/teknisk/Eldre kjøretøy Body Tag Eksempel.png'
    }, {
        label: 'Eksempel på Dekk tag',
        text: 'Denne er ofte lokalisert ved siden av ID tag i åpning eller på dørblad på førerdør.\n\nInneholder: Dekkdimensjoner og lufttrykk.',
        image: '/images/teknisk/Dekk Tag Eksempel.png'
    }, {
        label: 'Eksempel på ID-Vekt tag',
        text: 'Denne finner man i døråpning eller enden av dørblad på førerdør. Gjelder de fleste bilmodeller.\n\nInneholder: VIN, GVWR og GAWR.',
        image: '/images/teknisk/ID-Vekt Tag Eksempel.png'
    }, {
        label: 'GM RPO Tag Eksempel',
        text: 'Stort sett lokalisert i hanskerom for de flest modeller. Noen Camaro og Corvette modeller har den lokalisert i midtkonsoll eller bagasjerom.\n\nInneholder: Alle RPO koder for ekstrautstyr fra fabrikk.',
        image: '/images/teknisk/RPO Tag Eksempel.png'
    }]
};

var app = new Vue({
    el: '#ombygging-app',
    data: {
        // Member access
        isMember: window.TechnicalFormConfig ? window.TechnicalFormConfig.isMember : false,
        loginUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.loginUrl : '/Account/Login',
        registerUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.registerUrl : '/bli-medlem',

        currentStep: 1,
        loading: false,
        errors: {},

        // Sub-type
        subType: null,

        // Contact info
        memberNumber: '',
        name: '',
        address: '',
        zipCode: '',
        city: '',
        phone: '',
        email: '',

        // Vehicle info
        vinOrRegNumber: '',
        carMake: '',
        carModel: '',
        constructionYear: '',
        originalEngine: '',
        originalTransmission: '',

        // Sub-type specific fields
        conversionDescription: '',
        partsInfo: '',
        whatWasChanged: '',
        whatToChange: '',
        desiredParts: '',
        guidelinesQuestion: '',

        // Guidelines checkbox
        acceptedGuidelines: false,

        // Other comments
        otherComments: '',

        // File uploads - stored locally until form submission
        localFiles: [],

        // Example image modal
        activeExamples: null
    },
    computed: {
        tagsFiles: function tagsFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'tags';
            });
        },
        vedleggFiles: function vedleggFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'vedlegg';
            });
        },
        soknadVedtakFiles: function soknadVedtakFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'soknad-vedtak';
            });
        },
        delevalgVedleggFiles: function delevalgVedleggFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'delevalg-vedlegg';
            });
        },
        subTypeTitle: function subTypeTitle() {
            switch (this.subType) {
                case 'apply':
                    return 'Veiledning av søknad';
                case 'problems':
                    return 'Problemer med godkjenning';
                case 'questions':
                    return 'Spørsmål ved delevalg';
                case 'guidelines':
                    return 'Spørsmål ved retningslinjer';
                default:
                    return 'Ombygging';
            }
        },
        isApplyType: function isApplyType() {
            return this.subType === 'apply';
        }
    },
    mounted: function mounted() {
        var self = this;
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && self.activeExamples) {
                self.closeExamples();
            }
        });
    },
    methods: {
        showExamples: function showExamples(fileType) {
            this.activeExamples = FILE_EXAMPLES[fileType] || null;
            if (this.activeExamples) {
                document.body.style.overflow = 'hidden';
            }
        },
        closeExamples: function closeExamples() {
            this.activeExamples = null;
            document.body.style.overflow = '';
        },
        toggleZoom: function toggleZoom(event) {
            event.target.classList.toggle('zoomed');
        },
        selectMainType: function selectMainType(type) {
            if (!this.isMember) return;
            this.subType = type;
            this.currentStep = 2;
        },
        nextStep: function nextStep() {
            if (this.currentStep === 1 && this.subType) {
                this.currentStep = 2;
            }
        },
        prevStep: function prevStep() {
            if (this.currentStep === 2) {
                this.subType = null;
                this.currentStep = 1;
            }
        },
        validateForm: function validateForm() {
            this.errors = {};

            // Contact info validation
            if (!this.memberNumber) this.errors.memberNumber = 'Du må fylle ut medlemsnummer';
            if (!this.name) this.errors.name = 'Du må fylle ut navn';
            if (!this.address) this.errors.address = 'Du må fylle ut adresse';
            if (!this.zipCode) this.errors.zipCode = 'Du må fylle ut postnummer';
            if (!this.city) this.errors.city = 'Du må fylle ut poststed';
            if (!this.phone) this.errors.phone = 'Du må fylle ut telefonnummer';
            if (!this.email) this.errors.email = 'Du må fylle ut e-postadresse';

            if (this.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.errors.email = 'Ugyldig e-postadresse';
            }

            // Vehicle info validation
            if (!this.vinOrRegNumber) this.errors.vinOrRegNumber = 'Du må fylle ut VIN eller reg.nr.';
            if (!this.carMake) this.errors.carMake = 'Du må fylle ut bilmerke';
            if (!this.carModel) this.errors.carModel = 'Du må fylle ut modellbetegnelse';
            if (!this.constructionYear) this.errors.constructionYear = 'Du må fylle ut årsmodell';
            if (!this.originalEngine) this.errors.originalEngine = 'Du må fylle ut original motor';
            if (!this.originalTransmission) this.errors.originalTransmission = 'Du må velge original girtype';

            // Tags upload required
            var hasTags = this.localFiles.some(function (f) {
                return f.type === 'tags';
            });
            if (!hasTags) this.errors.tags = 'Du må laste opp kjøretøyets tags';

            // Sub-type specific validation
            if (this.subType === 'apply') {
                if (!this.conversionDescription) this.errors.conversionDescription = 'Du må fylle ut beskrivelse';
                if (!this.partsInfo) this.errors.partsInfo = 'Du må fylle ut deler info';
                var hasVedlegg = this.localFiles.some(function (f) {
                    return f.type === 'vedlegg';
                });
                if (!hasVedlegg) this.errors.vedlegg = 'Du må laste opp vedlegg';
            } else if (this.subType === 'problems') {
                if (!this.whatWasChanged) this.errors.whatWasChanged = 'Du må fylle ut hva som er endret';
                var hasSoknadVedtak = this.localFiles.some(function (f) {
                    return f.type === 'soknad-vedtak';
                });
                if (!hasSoknadVedtak) this.errors.soknadVedtak = 'Du må laste opp søknad og vedtak';
            } else if (this.subType === 'questions') {
                if (!this.whatToChange) this.errors.whatToChange = 'Du må fylle ut hva som skal endres';
                if (!this.desiredParts) this.errors.desiredParts = 'Du må fylle ut ønskede deler';
            } else if (this.subType === 'guidelines') {
                if (!this.guidelinesQuestion) this.errors.guidelinesQuestion = 'Du må fylle ut ditt spørsmål';
            }

            // Guidelines checkbox validation (not required for "Spørsmål ved retningslinjer")
            if (this.subType !== 'guidelines' && !this.acceptedGuidelines) this.errors.acceptedGuidelines = 'Du må bekrefte at du har lest retningslinjene';

            return Object.keys(this.errors).length === 0;
        },
        handleFileUpload: function handleFileUpload(event, fileType) {
            var files = event.target.files;
            if (!files || files.length === 0) return;

            var MAX_TOTAL_SIZE_BYTES = 52428800;
            var currentTotal = this.localFiles.reduce(function (sum, f) {
                return sum + f.file.size;
            }, 0);
            var incoming = 0;
            for (var j = 0; j < files.length; j++) {
                incoming += files[j].size;
            }
            if (currentTotal + incoming > MAX_TOTAL_SIZE_BYTES) {
                alert('Filene er for store. Maks totalstørrelse er 50 MB.');
                event.target.value = '';
                return;
            }

            // Store files locally - will be uploaded on form submission
            for (var i = 0; i < files.length; i++) {
                this.localFiles.push({
                    file: files[i],
                    name: files[i].name,
                    type: fileType
                });
            }

            event.target.value = '';
        },
        removeFile: function removeFile(file) {
            var index = this.localFiles.indexOf(file);
            if (index > -1) {
                this.localFiles.splice(index, 1);
            }
        },
        submitForm: function submitForm() {
            var self = this;
            if (!this.validateForm()) {
                var firstError = document.querySelector('.text-danger');
                if (firstError) {
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }

            this.loading = true;

            // Build FormData for multipart submission
            var formData = new FormData();

            formData.append('subType', this.subType);
            formData.append('memberNumber', this.memberNumber);
            formData.append('name', this.name);
            formData.append('address', this.address);
            formData.append('zipCode', this.zipCode);
            formData.append('city', this.city);
            formData.append('phone', this.phone);
            formData.append('email', this.email);
            formData.append('vinOrRegNumber', this.vinOrRegNumber);
            formData.append('carMake', this.carMake);
            formData.append('carModel', this.carModel);
            formData.append('constructionYear', this.constructionYear);
            formData.append('originalEngine', this.originalEngine);
            formData.append('originalTransmission', this.originalTransmission);
            formData.append('conversionDescription', this.conversionDescription || '');
            formData.append('partsInfo', this.partsInfo || '');
            formData.append('whatWasChanged', this.whatWasChanged || '');
            formData.append('whatToChange', this.whatToChange || '');
            formData.append('desiredParts', this.desiredParts || '');
            formData.append('guidelinesQuestion', this.guidelinesQuestion || '');
            formData.append('acceptedGuidelines', this.acceptedGuidelines);
            formData.append('otherComments', this.otherComments || '');

            // Add files with type-prefixed names
            this.localFiles.forEach(function (fileObj) {
                formData.append('files-' + fileObj.type, fileObj.file, fileObj.name);
            });

            axios.post('/teknisk/ombygging', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function () {
                window.location.href = '/teknisk/skjema/takk?skjema=' + encodeURIComponent(window.location.pathname);
            }).catch(function (error) {
                alert('En feil oppstod ved innsending av skjemaet. Vennligst prøv igjen.');
                self.loading = false;
            });
        }
    }
});